module.exports = __webpack_public_path__ + "static/media/wrecked-ship.f1750ccc.jpg";